<template>
  <div class="enter-order-container">
    <button class="filled yellow" :disabled="disableOrderBtn || disabled" @click="enterOrderProcess">
      <slot name="btn"></slot>
    </button>
  </div>
</template>

<script>

import customerContractState from '@/mixins/customerContractState'

export default {
  name: 'OrderBtn',
  props: {
    orderTargetUrl: {
      type: String,
      default: ''
    },
    simOrderStatus: {
      type: Object,
      default: () => {}
    },
    preOrder: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    enterOrderProcess: function () {
      if (typeof this.preOrder === 'function') {
        this.preOrder()
      }
      if (this.isOrderPossible) {
        window.location.href = this.orderTargetUrl
        this.$store.commit('checkoutv2/substituteSim/setSkippedSelection', false)
        this.$store.commit('checkoutv2/substituteSim/setStep', 'simData')
        return
      }
      let msg
      if (this.isOrderToEarly) {
        msg = this.$slots.errorToEarly?.[0]?.text
      }
      if (this.simOrderStatus.statusInfo === 'BlockedByCustomerStatus') {
        msg = this.$slots.errorCustomerStatus?.[0]?.text || this.fallbackErrorMessage
      }
      if (this.simOrderStatus.statusInfo === 'BlockedByDunningLevel') {
        msg = this.$slots.errorDunningLevel?.[0]?.text || this.fallbackErrorMessage
      }
      if (msg === undefined || msg === null) {
        msg = this.fallbackErrorMessage
      }
      this.errorToast(msg)
    }
  },
  computed: {
    fallbackErrorMessage: function () {
      return this.$slots.errorGeneric?.[0]?.text || 'Ufff! Leider kannst du derzeitig keine Ersatz-SIM-Karte bestellen (Fehler: ES1). Bitte wende dich einmal an die Hotline.'
    },
    disableOrderBtn: function () {
      return (!this.loadedContractState || this.contractTerminated)
    },
    isOrderPossible: function () {
      return this.simOrderStatus.orderable
    },
    isOrderToEarly: function () {
      if (this.simOrderStatus.orderDate === null) {
        return false
      }
      return this.timeSinceLatestOrder <= 30
    },
    timeSinceLatestOrder: function () {
      const today = new Date()
      const orderDate = new Date(this.simOrderStatus.orderDate)
      const diff = today.getTime() - orderDate.getTime()
      return Math.floor(diff / (1000 * 60 * 60 * 24))
    }
  },
  mixins: [
    customerContractState()
  ]
}
</script>
